export const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99967 3.08397C6.1797 3.08397 3.08301 6.18115 3.08301 10.0017C3.08301 13.8223 6.1797 16.9194 9.99967 16.9194C13.8196 16.9194 16.9163 13.8223 16.9163 10.0017C16.9163 6.18115 13.8196 3.08397 9.99967 3.08397ZM1.58301 10.0017C1.58301 5.35259 5.35128 1.58374 9.99967 1.58374C14.6481 1.58374 18.4163 5.35259 18.4163 10.0017C18.4163 14.6508 14.6481 18.4197 9.99967 18.4197C5.35128 18.4197 1.58301 14.6508 1.58301 10.0017ZM10.7497 8.33478V14.169H9.24967V8.33478H10.7497Z"
        fill="#3643BA"
      />
      <path
        d="M9.99971 7.25128C10.4139 7.25128 10.7497 6.91545 10.7497 6.50117C10.7497 6.08689 10.4139 5.75105 9.99971 5.75105C9.5855 5.75105 9.24971 6.08689 9.24971 6.50117C9.24971 6.91545 9.5855 7.25128 9.99971 7.25128Z"
        fill="#3643BA"
      />
    </svg>
  )
}
